import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const regex = /^\d+$/g;

const useGetValue = (key, concat = undefined) => {
  const state = useSelector((s) => s);

  const value = useMemo(() => {
    const parts = key.split('.');

    let subState = state;

    for (let i = 0; i < parts.length; i++) {
      if (concat && i === parts.length - 1) {
        const toReturn = [];

        for (let j = 0; j < concat.length; j++) {
          toReturn.push(subState[parts[i] + concat[j]]);
        }

        subState = toReturn;
      } else {
        let index = parts[i];

        if (index.match(regex)) {
          index = parseInt(index);
        }

        subState = subState[index];
      }
    }

    return subState;
  }, [state, key, concat]);

  return value;
};

export default useGetValue;
